export class IsTabelaSelecionadaItem {

    private idItem: number;
    private isTabelaSelecionada: boolean;

    constructor(json?: any) {    
        if (json) {       
            // Inicialização a partir do objeto JSON
            this.idItem = json.idItem;
			this.isTabelaSelecionada = json.isTabelaSelecionada;
        } 
    }

    get getIdItem():number {
        return this.idItem;
    }

    _setIdItem(idItem: number): void {
        this.idItem = idItem;
    }

    get getIsTabelaSelecionada():boolean {
        return this.isTabelaSelecionada;
    }

    _setIsTabelaSelecionada(isTabelaSelecionada: boolean): void {
        this.isTabelaSelecionada = isTabelaSelecionada;
    }
}

